import { render, staticRenderFns } from "./MediaFavourites.vue?vue&type=template&id=76c54711&scoped=true"
import script from "./MediaFavourites.vue?vue&type=script&lang=js"
export * from "./MediaFavourites.vue?vue&type=script&lang=js"
import style0 from "./MediaFavourites.vue?vue&type=style&index=0&id=76c54711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c54711",
  null
  
)

export default component.exports